import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "wdw-filter-form",
  class: "wdw-form"
}
const _hoisted_2 = {
  class: "btn btn-success btn-form-submit btn-submit-filter",
  type: "submit"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Filter anwenden ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Filter verwerfen ")

import { Input as FormControlInput } from 'wdw-library/dist/esm/Input';
// eslint-disable-next-line
//@ts-ignore
import { Select as FormControlSelect } from 'wdw-library/dist/esm/Select';
// eslint-disable-next-line
//@ts-ignore
import WdwDynbox from '@/components/general/WdwDynbox.vue';
import { UrlParams } from '@vueuse/core';
import { Form } from 'vee-validate';
import { PropType, onMounted, ref, watch } from 'vue';

import categoryRepository from '@/api/categoryRepository';
import domainRepository from '@/api/domainRepository';
import { FormControlOptions } from '@/models/form-control.model';
import { useForm } from 'vee-validate';

interface FilterOptions {
  label: string;
  type: string;
  name: string;
  options?: FormControlOptions[];
  defaultvalue: string;
  class?: string;
}

interface FilterRow {
  [key: string]: FilterOptions;
}

interface Filters {
  row1: FilterRow;
  row2: FilterRow;
}


export default /*#__PURE__*/_defineComponent({
  props: {
  params: { type: Object as PropType<UrlParams>, required: true },
  toggleMinimize: { type: Boolean, required: false, default: false },
},
  emits: ['onSetUrlParams', 'emitOptionSelected', 'removeFilter'],
  setup(__props, { emit }) {

const props = __props

// eslint-disable-next-line
//@ts-ignore

const { handleSubmit } = useForm();


const selectRefs: any = ref([]);
const selectEl = { itemRefs: selectRefs };
const inputRefs: any = ref([]);
const inputEl = { itemRefs: inputRefs };

const filters = ref<Filters>({
  row1: {
    messageid: { label: 'Nummer', type: 'number', name: 'messageid', defaultvalue: '', class: 'col-md-4' },
    text: { label: 'Text', type: 'text', name: 'text', defaultvalue: '', class: 'col-md-8' },
  },
  row2: {
    state: { label: 'Status', type: 'valuelist', name: 'state', options: [], defaultvalue: '', class: 'col-md-4' },
    category: { label: 'Kategorie', type: 'valuelist', name: 'type', options: [], defaultvalue: '', class: 'col-md-4' },
    sort: {
      label: 'Sortierung',
      type: 'valuelist',
      name: 'sort',
      options: [
        { id: '-id', text: 'ID (absteigend)' },
        { id: '+id', text: 'ID (aufsteigend)' },
      ],
      defaultvalue: '-id',
      class: 'col-md-4',
    },
    address: { label: 'Adresse', type: 'text', name: 'address', defaultvalue: '', class: 'col-md-4' },
  },
});

const applyFilter = handleSubmit(values => {
  emit('onSetUrlParams', values, true);
});

function resetFilter() {
  //reset Inputs
  selectRefs.value?.forEach((select: any) => {
    if (select.name !== 'sort') {
      select.resetSelect();
    }
  });
  inputRefs.value.forEach((input: any) => {
    input.setValue('');
  });

  emit('onSetUrlParams', {});
}

function getAndSetStateOptions() {
  domainRepository.getBmsStatusList().then(response => {
    filters.value.row2.state.options = response;
  });
}

function getAndSetCategoryOptions() {
  categoryRepository.getCategoriesByQueryParams().then(response => {
    filters.value.row2.category.options = response.map(category => {
      return { id: category.id, text: category.name };
    });
  });
}

function setDefaultValuesFromURLHash() {
  if (props.params.messageid && props.params.detail) {
    return;
  }
  //other inputs
  Object.entries(props.params).forEach((param: any) => {
    Object.values(filters.value).forEach((filterRow: any) => {
      Object.entries(filterRow).forEach((filter: any) => {
        if (param[0] == filter[0]) {
          if (filter[1].type == 'number' || filter[1].type == 'text') {
            inputRefs.value.forEach((input: any) => {
              if (input.name == param[0]) {
                input.setValue(param[1]);
              }
            });
          }
        }
        selectRefs.value.forEach((select: any) => {
          if (select.name == param[0]) {
            select.value = param[1];
          }
        });
      });
    });
  });
}
onMounted(() => {
  getAndSetStateOptions();
  getAndSetCategoryOptions();
  //set defaultvalues from url-hash
  setDefaultValuesFromURLHash();
});
watch(
  () => props.params,
  () => {
    setDefaultValuesFromURLHash();
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(WdwDynbox, {
    title: "Suche",
    config: { showControls: true },
    minimize: __props.toggleMinimize
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(applyFilter) && _unref(applyFilter)(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filters.value, (filterRow, key) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row",
              key: key
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterRow, (filter, filterKey) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: filterKey,
                  class: _normalizeClass(filter.class)
                }, [
                  (filter.type == 'number' || filter.type == 'text')
                    ? (_openBlock(), _createBlock(_unref(FormControlInput), {
                        key: 0,
                        ref_for: true,
                        ref: inputEl.itemRefs,
                        additionalLabelClasses: 'wdw-filter-label',
                        label: filter.label,
                        type: filter.type,
                        name: filter.name,
                        defaultvalue: filter.defaultvalue
                      }, null, 8, ["label", "type", "name", "defaultvalue"]))
                    : _createCommentVNode("", true),
                  (filter.type == 'valuelist')
                    ? (_openBlock(), _createBlock(_unref(FormControlSelect), {
                        key: 1,
                        ref_for: true,
                        ref: selectEl.itemRefs,
                        additionalLabelClasses: 'wdw-filter-label',
                        label: filter.label,
                        type: filter.type,
                        name: filter.name,
                        defaultvalue: [filter.defaultvalue],
                        options: filter.options,
                        allowClear: true
                      }, null, 8, ["label", "type", "name", "defaultvalue", "options"]))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ]))
          }), 128))
        ]),
        _createElementVNode("button", _hoisted_2, [
          _createVNode(_component_font_awesome_icon, { icon: "filter" }),
          _hoisted_3
        ]),
        _hoisted_4,
        _createElementVNode("button", {
          class: "btn btn-danger btn-reset-filter",
          onClick: resetFilter
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "trash-alt" }),
          _hoisted_5
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["minimize"]))
}
}

})